







import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryCouponGrantLogList, ExportCouponGrantLogList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({ components: { VQuery, VTable } })
export default class CouponGrantLogList extends Vue {
  private queryParam: any = { startRow: 1, limit: 10, createTimeDaterange: [] }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '用户ID', param: 'userId' },
    { title: '模板ID', param: 'couponTemplateId' },
    { title: '发放来源', param: 'grantSource' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'warning', click: this.exportHandle },
  ]

  private tableHander: Array<TableHander> = [
    { title: 'ID', param: 'id', width: 70 },
    { title: '用户ID', param: 'userId', width: 90 },
    { title: '昵称', param: 'userNickname', width: 100 },
    { title: '手机号', param: 'mobilePhone', width: 120 },
    { title: '模板', param: 'templateName', minWidth: 120 },
    { title: '用户券ID', param: 'userCouponId', width: 90 },
    { title: '来源', param: 'grantSource', width: 120 },
    { title: '操作人', param: 'operator', width: 100 },
    { title: '时间', param: 'createTime', width: 160, formatter: DateFormat },
    { title: '备注', param: 'note', overflow: true },
  ]

  activated() {
    this.loadData()
  }

  created() {
    this.loadData()
  }

  private async loadData() {
    const result = await QueryCouponGrantLogList(this.getRequestParam())
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param = this.buildExportParam()
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    return param
  }

  private buildExportParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    delete param.createTimeDaterange
    delete param.startRow
    delete param.limit
    return param
  }

  search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private exportHandle() {
    const loading = this.$loading({
      lock: true,
      text: '正在导出',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    const param = this.buildExportParam()
    ExportCouponGrantLogList(param, '优惠券发放记录.xlsx')
      .then(() => loading.close())
      .catch(() => loading.close())
  }
}
